/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: ryanxu ryanxu@chaocanshu.ai
 * @LastEditTime: 2026-03-27 16:23:22
 * @FilePath: /knit-web/src/locale/en-US/configuration.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  configuration: {
    title: 'My Configurations',
    managed: {
      label: 'Managed',
      description:
        'View and manage internal resources allocated to this workspace.',
    },
    external: {
      label: 'External',
      description:
        'In External Configurations, you can configure and manage external AI models, databases, cloud storage, and message channels.',
    },
    resourceType: 'Resource Type',
    resourceName: 'Resource Name',
    usedBy: 'Used by {num} workflows',
    searchProvider: 'Search provider...',
    all: 'All',
    aiModel: 'AI Model',
    database: 'Databases',
    storage: 'Cloud Storage',
    message: 'Messaging',
    webSearch: 'Web Search',
    configure: 'Config',
    add: 'Add New',
    manage: 'Manage',
    edit: 'Edit',
    delete: 'Delete',
    test: 'Test',
    testSuccess: 'Connection successful',
    testFailed: 'Connection failed',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Failed to save',
    addConfigTitle: 'Add Configuration - {name}',
    editConfigTitle: 'Edit Configuration - {name}',
    mysql: {
      configTitle: 'External MySQL Connection Configuration',
      name: 'Connection Configuration Name',
      namePlaceholder: 'A name to identify this configuration',
      host: 'MySQL Host',
      port: 'MySQL Port',
      user: 'User',
      password: 'Password',
      database: 'Database',
    },
    description: 'Description',
    descriptionPlaceholder: 'Please enter a description (optional)',
    configParams: 'Configuration Parameters',
    noTemplate: 'No configuration template for this provider',
    addConfig: 'Add Configuration',
    noConfig: 'No configuration found',
    status: {
      active: 'Active',
      inactive: 'Inactive',
      error: 'Error',
    },
    createdAt: 'Created at {time}',
    connectionNormal: 'Connection normal',
    deleteConfirmTitle: 'Are you sure you want to delete this configuration?',
    configList: 'Configuration List',
    version: 'Version',
    resourcePricing: 'Resource Pricing',
    resourceLimits: 'Resource Limits',
    pricingItem: 'Pricing Item',
    limitItem: 'Limit Item',
    unit: 'Unit',
    value: 'Value',
    limitDefinition: 'Limit Definition',
    loading: 'Loading...',
    search: 'Search',
    latency: 'Latency',
    configDetail: 'Configuration Detail',
    vendor: 'Vendor',
    noData: 'No Data',
    other: 'Other',
    configuration: 'Configuration',
    unconfigured: 'Unconfigured',
    email: {
      smtpServer: 'SMTP Server',
      smtpServerDesc: 'SMTP server address, e.g., smtp.example.com',
      port: 'Port',
      portDesc: 'SMTP service port number',
      username: 'Username',
      usernameDesc: 'SMTP username/email address',
      password: 'Password',
      passwordDesc: 'SMTP password or app-specific password',
      from: 'From Address',
      fromDesc: 'Sender email address, e.g., sender@example.com',
      fromName: 'From Name',
      fromNameDesc: 'Sender display name (optional)',
      subject: 'Subject',
      subjectDesc: 'Email subject, supports template variables like {{title}}',
      isHtml: 'Is HTML',
      isHtmlDesc: 'Whether to send HTML format email',
      useTls: 'Use TLS',
      useTlsDesc: 'Whether to use TLS encryption',
    },
    // AI Model general configuration
    aiModelConfig: {
      configTitle: '{provider} Configuration',
      providerKeyTitle: '{provider} API Key Configuration',
      modelKeyTitle: '{provider} Specific Model Configuration',
      configType: 'Configuration Type',
      providerKey: 'API Key Configuration',
      modelKey: 'Specific Model Configuration',
      configName: 'Configuration Name',
      configNamePlaceholder: 'A name to identify this configuration',
      configNameDesc: 'If not filled, system will auto-generate default name',
      apiKeyRequired: 'API Key is required',
      modelName: 'Model Name',
      modelNameRequired: 'Model Name is required',
      modelType: 'Model Type',
      modelTypeRequired: 'Model Type is required',
      modelTypeLLM: 'LLM',
      modelTypeEmbedding: 'Text Embedding',
      modelTypeSTT: 'ASR',
      modelTypeModeration: 'Moderation',
      modelTypeTTS: 'TTS',
      modelTypeVideoParser: 'Video Parser',
      modelTypeImageGeneration: 'Image Generation',
      modelTypeImageUnderParser: 'Image Parser',
      modelTypeVideoGeneration: 'Video Generation',
      modelType3DGeneration: '3D Generation',
      modelTypeRerank: 'Rerank',
      selectModelType: 'Select Model Type',
      testApiKey: 'Test API Key',
      getModelList: 'Get Model List',
      fillRequiredFields: 'Please fill in required authentication fields first',
      testing: 'Loading...',
      testSuccess: 'Model list retrieved successfully',
      testFailed: 'Failed to retrieve model list',
      availableModels: 'Available Models',
      matchedModels: 'The following models can be added',
      needsInfoModels:
        'There are {count} more models that need additional information before adding',
      addModel: 'Add Model',
      modelNameCol: 'Model Name',
      modelTypeCol: 'Model Type',
      missingTenantOrWorkspace: 'Missing tenant or workspace information',
      selectAtLeastOneModel: 'Please select at least one model',
      configCreateSuccess: 'Configuration created successfully',
      configCreateFailed: 'Failed to create configuration',
      configUpdateSuccess: 'Configuration updated successfully',
      configUpdateFailed: 'Failed to update configuration',
      // Get API Key links
      getApiKeyFromOpenAI: 'Get your API Key from OpenAI',
      getApiKeyFromAnthropic: 'Get your API Key from Anthropic',
      getApiKeyFromGoogle: 'Get your API Key from Google AI Studio',
      getApiKeyFromDeepSeek: 'Get your API Key from DeepSeek',
    },
    missingProviderInfo: 'Missing provider information',
  },
};
